// This file is automatically generated. Do not edit manually.

import { t } from "i18next";

export const ReclamationStateValues = ["INITIAL", "PLANNED", "RELEASED", "READY_FOR_REVIEW", "CLOSED"] as const;

export type ReclamationState = (typeof ReclamationStateValues)[number];

export const getReclamationStateLabels = () => ({
	INITIAL: t("initial"),
	PLANNED: t("planned"),
	RELEASED: t("released"),
	READY_FOR_REVIEW: t("ready_for_review"),
	CLOSED: t("closed"),
});

export const getReclamationStateLabel = (value: ReclamationState): string => {
	return getReclamationStateLabels()[value];
};
